/**
 * AuthLoadingFallback Component
 *
 * Loading state component shown during authentication route transitions.
 * Prevents white flash when navigating between auth routes by maintaining
 * consistent UI during React Suspense boundary loading.
 *
 * WHY THIS COMPONENT:
 * - Route transitions were causing flash to home screen
 * - Suspense boundary needs consistent fallback UI
 * - Maintains auth layout visual continuity during navigation
 * - Minimal UI prevents jarring transitions
 *
 * USAGE:
 * Used as fallback prop in React Suspense wrapper around auth routes in App.jsx
 * Shows during lazy loading of auth components or route transitions
 *
 * @see App.jsx - Suspense boundary implementation
 * @see AuthLayout.jsx - Layout wrapper for consistent auth UI
 */

import AuthLayout from "./AuthLayout";
import Spinner from "../../ui/Spinner";

function AuthLoadingFallback(): JSX.Element {
  return (
    <AuthLayout variant="centered">
      <Spinner />
    </AuthLayout>
  );
}

export default AuthLoadingFallback;
